"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsAgreeFinancial = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var agreement_1 = require("../../model/agreement");
var service_1 = require("../../../library/base/service");
var IsAgreeFinancial = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IsAgreeFinancial, _super);
    function IsAgreeFinancial() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '判断用户是否同意高端理财协议接口';
        _this.code = '101107';
        _this.desc = '判断用户是否同意高端理财协议接口';
        _this.requestParams = new agreement_1.IsAgreeFinancialRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return IsAgreeFinancial;
}(service_1.BaseService));
exports.IsAgreeFinancial = IsAgreeFinancial;
//# sourceMappingURL=isAgreeFinancial.js.map